import { render, staticRenderFns } from "./Technical-monitoring.vue?vue&type=template&id=b22d9680&scoped=true&"
import script from "./Technical-monitoring.vue?vue&type=script&lang=js&"
export * from "./Technical-monitoring.vue?vue&type=script&lang=js&"
import style0 from "./Technical-monitoring.vue?vue&type=style&index=0&id=b22d9680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b22d9680",
  null
  
)

export default component.exports